export class StatusIcon {
  public static OnFilterApplied(input: string) {
    let iconName;
    switch (input) {
      case 'neutral':
        iconName = 'error_outline';
        break;
      case 'positive':
        iconName = 'done';
        break;
      case 'expired':
        iconName = 'hourglass_empty';
        break;
      default:
        iconName = 'clear';
        break;
    }
    return iconName;
  }
}